export default "__VITE_ASSET__BJcOug$b__"